import React from 'react';
import Datas from '../../data/service/mondiya/service-box-two.json';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "../styles/mondiya/serviceBoxTwo.js";
import {useTranslation} from "react-i18next";

const ServiceBoxTwo = () => {
    const { t } = useTranslation();
    return (
        <Styles>
            {/* Service Box */}
            <section className="service-area">
                <Container>
                    <Row>
                        <Col md="12">
                            <div className="sec-title text-center">
                                <h4>{t(`home.whyChooseUs.secTitle`)}</h4>
                                <p className="sec-para">{t(`home.whyChooseUs.secDesc1`)}</p>
                                <p className="sec-para">{t(`home.whyChooseUs.secDesc2`)}</p>
                            </div>
                        </Col>
                        {
                            Datas.dataList.map((data, i) => (
                                <Col md="4" key={i}>
                                    <div className="service-box d-flex">
                                        <div className="box-icon">
                                            <i className={data.boxIcon}></i>
                                        </div>
                                        <div className="box-title">
                                            <h6>{t(`home.whyChooseUs.list.${i}.title`)}</h6>
                                            <p>{t(`home.whyChooseUs.list.${i}.subTitle`)}</p>
                                        </div>
                                    </div>
                                </Col>
                            ))
                        }
                    </Row>
                </Container>
            </section>
        </Styles>
    )
}

export default ServiceBoxTwo